import { render, staticRenderFns } from "./PasswordStore.vue?vue&type=template&id=92a9a852"
import script from "./PasswordStore.vue?vue&type=script&lang=js"
export * from "./PasswordStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports